import Calendar from './calendar.png';
import PaperclipIcon from './paperclip.png';
import UserIcon from './user.png';
import ArrowLeft from './arrow-left.png';
import LockIcon from './lock.png';
import PasswordInactive from './password-inactive.png';
import PasswordActive from './password-active.png';
import LogoutIcon from './logout.png';
import ProfileIcon from './profile.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import AddIcon from './add.png';
import SearchIcon from './search.png';
import TrashIcon from './trash.png';
import ArrowUp from './arrow-up.png';
import ArrowBottom from './arrow-bottom.png';
import ViewIcon from './view.png';
import MailIcon from './mail.png';
import TimeIcon from './time.png';
import ArrowBottomBlack from './arrow-bottom-black.png';
import ArrowUpBlack from './arrow-up-black.png';
import CalendarWhite from './calendar-white.png';
import DeleteIcon from './delete.png';
import CalendarRed from './calendar-red.png';
import CloseIcon from './close.png';
import CheckGreenIcon from './check-green.png';
import MenuIcon from './menu.png';
import LogoutGray from './logout-gray.png';
import ArrowLeft2 from './arrow-left2.png';
import LocationIcon from './location.png';
import PhoneIcon from './phone.png';
import FacebookIcon from './facebook.png';
import InstagramIcon from './instagram.png';
import WebIcon from './web.png';
import CleanIcon from './clean.png';
import ArrowRight from './arrow-right.png';
import UploadIcon from './upload.png';
import ArrowLeftBlack from './arrow-left-black.png';
import ArrowRightBlack from './arrow-right-black.png';
import CheckWhiteIcon from './check-white.png';
import StarIcon from './star.png';
import StarActiveIcon from './star-active.png';
import XLSIcon from './xls.png';
import Download2Icon from './download2.png';
import EyeBlackIcon from './eye-black.png';
import DownloadBlackIcon from './download-black.png';
import AlertIcon from './alert.png';
import ModeratorIcon from './moderator.png';
import EditBlueIcon from './edit-blue.png';
import PrintIcon from './print.png';
import AssignIcon from './assign.png';
import IconUsers from './icon-users.png';
import UserSettings from './user-settings.png';
import DownloadExcelIcon from './download-excel.png';
import GoogleMapsIcon from './google-maps.png';
import PercentageIcon from './percentage.png';
import BankIcon from './bank.png';
import ListIcon from './list.png';
import PaymentIcon from './payments.png';
import DocumentIcon from './documents.png';
import CodingIcon from './coding.png';
import CopyIcon from './copy.png';
import CaretIcon from './caret.png';
import MenuCloseIcon from './menu-close.png';
import MenuOpenIcon from './menu-open.png';
import Home1Icon from './home1.png';
import Home2Icon from './home2.png';
import Home3Icon from './home3.png';
import Home4Icon from './home4.png';
import Messages1Icon from './messages1.png';
import Messages2Icon from './messages2.png';
import Messages3Icon from './messages3.png';
import SandClockIcon from './sand-clock.png';
import CampaignUserIcon from './campaign-users.png';
import CampaignListIcon from './campaign-list.png';
import CampaignTitleIcon from './campaign-title.png';
import UserListIcon from './user-list.png';
import ClockIcon from './clock.png';

// Menu
import Menu1 from './menu/menu1.png';
import Menu2 from './menu/menu2.png';
import Menu3 from './menu/menu3.png';
import Menu4 from './menu/menu4.png';
import Menu5 from './menu/menu5.png';
import Menu6 from './menu/menu6.png';
import Menu7 from './menu/menu7.png';
import Menu8 from './menu/menu8.png';
import Menu9 from './menu/menu9.png';
import Menu10 from './menu/menu10.png';
import Menu1Active from './menu/menu1-active.png';
import Menu2Active from './menu/menu2-active.png';
import Menu3Active from './menu/menu3-active.png';
import Menu4Active from './menu/menu4-active.png';
import Menu5Active from './menu/menu5-active.png';
import Menu6Active from './menu/menu6-active.png';
import Menu7Active from './menu/menu7-active.png';
import Menu8Active from './menu/menu8-active.png';
import Menu9Active from './menu/menu9-active.png';
import Menu10Active from './menu/menu10-active.png';

const Menu = {
	Menu1,
	Menu2,
	Menu3,
	Menu4,
	Menu5,
	Menu6,
	Menu7,
	Menu8,
	Menu9,
	Menu10,
	Menu1Active,
	Menu2Active,
	Menu3Active,
	Menu4Active,
	Menu5Active,
	Menu6Active,
	Menu7Active,
	Menu8Active,
	Menu9Active,
	Menu10Active
}

export {
	Calendar,
	ArrowLeft,
	PaperclipIcon,
	UserIcon,
	LockIcon,
	PasswordInactive,
	PasswordActive,
	LogoutIcon,
	ProfileIcon,
	DownloadIcon,
	EditIcon,
	AddIcon,
	SearchIcon,
	TrashIcon,
	ArrowUp,
	ArrowBottom,
	ViewIcon,
	MailIcon,
	TimeIcon,
	ArrowBottomBlack,
	ArrowUpBlack,
	CalendarWhite,
	DeleteIcon,
	CalendarRed,
	CloseIcon,
	CheckGreenIcon,
	Menu,
	MenuIcon,
	LogoutGray,
	ArrowLeft2,
	LocationIcon,
	WebIcon,
	InstagramIcon,
	FacebookIcon,
	PhoneIcon,
	CleanIcon,
	ArrowRight,
	UploadIcon,
	ArrowLeftBlack,
	ArrowRightBlack,
	CheckWhiteIcon,
	StarActiveIcon,
	StarIcon,
	XLSIcon,
	Download2Icon,
	EyeBlackIcon,
	DownloadBlackIcon,
	AlertIcon,
	ModeratorIcon,
	EditBlueIcon,
	PrintIcon,
	AssignIcon,
	IconUsers,
	UserSettings,
	DownloadExcelIcon,
	GoogleMapsIcon,
	PercentageIcon,
	BankIcon,
	PaymentIcon,
	ListIcon,
	DocumentIcon,
	CodingIcon,
	CopyIcon,
	CaretIcon,
	MenuOpenIcon,
	MenuCloseIcon,
	Home1Icon,
	Home2Icon,
	Home3Icon,
	Home4Icon,
	Messages1Icon,
	Messages2Icon,
	Messages3Icon,
	SandClockIcon,
	CampaignUserIcon,
	CampaignListIcon,
	CampaignTitleIcon,
	UserListIcon,
	ClockIcon
}